import { render, staticRenderFns } from "./KidsAppUsagesAlerts.vue?vue&type=template&id=081b3ae6&scoped=true&"
import script from "./KidsAppUsagesAlerts.vue?vue&type=script&lang=js&"
export * from "./KidsAppUsagesAlerts.vue?vue&type=script&lang=js&"
import style0 from "./KidsAppUsagesAlerts.vue?vue&type=style&index=0&id=081b3ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b3ae6",
  null
  
)

export default component.exports